export default {
  state: {
    bodyPartQuery: null,
    injuredCategoryQuery: null,
    accidentClassificationQuery: null,
    dangerConditionQuery: null,
    leadingQuery: null,
    accidentSourceQuery: null,
    dangerActionQuery: null,
    accidentTypeQuery: null,
    performanceReportQuery: null,
    incidentReportQuery: null,
    leadingReportQuery: null
  },
  mutations: {
    setBodyPartPageQuery(state, payload) {
      state.bodyPartQuery = payload
    },
    setInjuredCategoryPageQuery(state, payload) {
      state.injuredCategoryQuery = payload
    },
    setLeadingPageQuery(state, payload) {
      state.leadingQuery = payload
    },
    setDangerConditionPageQuery(state, payload) {
      state.dangerConditionQuery = payload
    },
    setAccidentClassificationPageQuery(state, payload) {
      state.accidentClassificationQuery = payload
    },
    setAccidentSourcePageQuery(state, payload) {
      state.accidentSourceQuery = payload
    },
    setDangerActionPageQuery(state, payload) {
      state.dangerActionQuery = payload
    },
    setAccidentTypePageQuery(state, payload) {
      state.accidentTypeQuery = payload
    },
    setPerformanceReportPageQuery(state, payload) {
      state.performanceReportQuery = payload
    },
    setIncidentReportPageQuery(state, payload) {
      state.incidentReportQuery = payload
    },
    setLeadingReportPageQuery(state, payload) {
      state.leadingReportQuery = payload
    }
  },
  actions: {},
  getters: {
    getBodyPartPageQuery(state) {
      return state.bodyPartQuery
    },
    getInjuredCategoryPageQuery(state) {
      return state.injuredCategoryQuery
    },
    getAccidentClassificationPageQuery(state) {
      return state.accidentClassificationQuery
    },
    getDangerConditionPageQuery(state) {
      return state.dangerConditionQuery
    },
    getLeadingPageQuery(state) {
      return state.leadingQuery
    },
    getAccidentSourcePageQuery(state) {
      return state.accidentSourceQuery
    },
    getDangerActionPageQuery(state) {
      return state.dangerActionQuery
    },
    getAccidentTypePageQuery(state) {
      return state.accidentTypeQuery
    },
    getPerformanceReportPageQuery(state) {
      return state.performanceReportQuery
    },
    getIncidentReportPageQuery(state) {
      return state.incidentReportQuery
    },
    getLeadingReportPageQuery(state) {
      return state.leadingReportQuery
    }
  }
}
